import React, { useState, useRef, useEffect } from "react";
import { DropdownIcon } from "../../../fixedassetelements/button/Button";
import styles from "./CustomDropdown.module.css";

const CustomDropdown = ({
  label,
  required = false,
  value = "",
  onChange,
  options = [],
  placeholder = "Select Option",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState(options);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleSelect = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    onChange(inputValue);

    const filtered = options.filter((opt) =>
      opt.toLowerCase().includes(inputValue.toLowerCase())
    );

    setFilteredOptions(filtered);
    setIsOpen(true);
  };

  useEffect(() => {
    setFilteredOptions(options);
  }, [options]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className={styles.fieldGroup} ref={dropdownRef}>
      {label && (
        <label className={styles.label}>
          {required && <span className={styles.required}>* </span>}
          {label}
        </label>
      )}

      <div className={styles.dropdownContainer}>
        <div className={styles.inputWrapper} onClick={toggleDropdown}>
          <input
            type="text"
            className={styles.input}
            placeholder={placeholder}
            value={value}
            onChange={handleInputChange}
            onFocus={() => setIsOpen(true)}
          />
        </div>

        <div className={styles.iconWrapper}>
          <DropdownIcon />
        </div>

        {isOpen && (
          <div className={styles.dropdownMenu}>
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option, index) => (
                <div
                  key={index}
                  className={styles.dropdownItem}
                  onClick={() => handleSelect(option)}
                >
                  {option}
                </div>
              ))
            ) : (
              <div className={styles.dropdownItem}>
                No results found
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomDropdown;